import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@famly/mf_data-display_text';
export const ModalDescription = ({ description }) => {
    return (_jsx(Text, { variant: "body-small", color: "n300", children: description }));
};
